<template>
  <div>
    <b-alert v-if="validationError.length" variant="danger" show>{{
      validationError
    }}</b-alert>

    <b-alert v-if="error.length" variant="danger" show>{{ error }}</b-alert>

    <div v-if="isBusy">
      <div class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Andmeid laetakse..</strong>
      </div>
    </div>

    <b-form
      v-else-if="!error.length && (!status || status == 'draft')"
      @submit="onSubmit"
    >
      <b-form-group
        v-for="field in formFields.question"
        :id="'fieldset-' + field.key"
        :label="field.label"
        :label-for="field.key"
        :description="field.description"
        :invalid-feedback="field.invalidFeedback"
        :state="field.invalidFeedback ? false : true"
        :key="field.key"
      >
        <input
          v-if="field.type == 'hidden'"
          type="hidden"
          :id="field.key"
          v-model="formValues[field.key]"
        />

        <b-form-input
          v-if="field.type == 'text'"
          type="text"
          :id="field.key"
          v-model="formValues[field.key]"
        ></b-form-input>

        <div v-if="field.type == 'file'" class="bg-secondary image-preview">
          <b-img :src="formValues[field.key]"></b-img>
          <button
            v-if="formValues[field.key]"
            @click="setNull(field.key)"
            type="button"
            aria-label="Close"
            class="close"
          >
            ×
          </button>
        </div>

        <b-input-group v-if="field.type == 'color'" prepend="#">
          <b-form-input
            type="text"
            :id="field.key"
            v-model="formValues[field.key]"
            :style="{
              'background-color':
                '#' +
                (formValues[field.key] && formValues[field.key].length == 6
                  ? formValues[field.key]
                  : 'FFF')
            }"
            maxlength="6"
          ></b-form-input>
        </b-input-group>

        <b-form-file
          v-if="field.type == 'file'"
          :id="field.key"
          placeholder="Vali (.svg) fail, või lohista see siia.."
          drop-placeholder="Lohista (.svg) fail siia.."
          accept=".svg"
          v-model="tmpSponsorLogo"
        ></b-form-file>

        <ckeditor
          v-if="field.type == 'ckeditor'"
          :id="field.key"
          :editor="editor"
          :config="editorConfig"
          tag-name="textarea"
          v-model="formValues[field.key]"
        ></ckeditor>

        <b-form-checkbox-group
          v-if="field.type == 'contactoptions'"
          :options="contactOptions"
          buttons
          :name="field.key"
          button-variant="outline-primary"
          v-model="formValues[field.key]"
        ></b-form-checkbox-group>

        <datetime
          v-if="field.type == 'datetime'"
          :id="field.key"
          type="datetime"
          :min-datetime="new Date().toISOString()"
          value-zone="local"
          v-model="formValues[field.key]"
          input-class="form-control"
          auto
        ></datetime>

        <div v-if="field.type == 'options'">
          <b-card
            v-for="(option, index) in formValues.options"
            :key="index"
            class="mb-2"
          >
            <b-card-text>
              <b-form-group
                v-for="field in formFields.options"
                :key="field.key"
                :id="'fieldset-' + field.key + '-' + index"
                :label="field.label"
                :label-for="field.key + '-' + index"
              >
                <input
                  v-if="field.type == 'hidden'"
                  type="hidden"
                  :id="field.key"
                  v-model="formValues.options[index][field.key]"
                />

                <b-form-input
                  v-if="field.type == 'text'"
                  type="text"
                  :id="field.key"
                  v-model="formValues.options[index][field.key]"
                ></b-form-input>

                <b-form-radio-group
                  v-if="field.type == 'boolean'"
                  :options="[{text:'Ei', value: 0},{text:'Jah', value: 1}]"
                  v-model="formValues.options[index][field.key]"
                  button-variant="outline-primary"
                  buttons
                ></b-form-radio-group>

                <div
                  v-if="field.type == 'file'"
                  class="bg-secondary image-preview"
                >
                  <b-img :src="formValues.options[index][field.key]"></b-img>
                  <button
                    v-if="formValues.options[index][field.key]"
                    @click="setNull(field.key, index, 'options')"
                    type="button"
                    aria-label="Close"
                    class="close"
                  >
                    ×
                  </button>
                </div>
                <b-form-file
                  v-if="field.type == 'file'"
                  :id="field.key"
                  placeholder="Vali (.svg) fail, või lohista see siia.."
                  drop-placeholder="Lohista (.svg) fail siia.."
                  accept="image/svg"
                  v-model="tmpOptionsIcon[index]"
                ></b-form-file>
              </b-form-group>
            </b-card-text>

            <b-button @click="removeOption(index)" variant="outline-danger"
              >Kustuta vastusevariant</b-button
            >
          </b-card>

          <b-button @click="addOption" class="mt-2" variant="outline-primary"
            >Lisa vastusevariant</b-button
          >
        </div>
      </b-form-group>

      <b-button type="submit" class="mb-2" variant="primary">Salvesta</b-button>

      <b-button
        v-if="status == 'draft'"
        @click="startVoting"
        class="mb-2 ml-2"
        variant="success"
        >Ava hääletamine</b-button
      >

      <b-button
        v-if="status == 'draft'"
        @click="deleteQuestion"
        class="mb-2 ml-2"
        variant="danger"
        >Kustuta</b-button
      >

      <b-button variant="info" class="mb-2 ml-2" v-b-modal.modal-live-preview
        >Live eelvaade</b-button
      >

      <b-modal
        id="modal-live-preview"
        title="Tele live eelvaade"
        body-bg-variant="secondary"
        hide-footer
      >
        <live-preview :question="formValues"></live-preview>
      </b-modal>
    </b-form>

    <div v-else-if="!error.length">
      <b-alert variant="info" show
        >Hääletamise algus on möödas, enam muudatusi teha ei ole
        võimalik</b-alert
      >
      <b-list-group class="mb-2">
        <b-list-group-item
          v-for="field in formFields.question"
          :key="field.key"
        >
          <strong v-if="field.label"> {{ field.label }}: </strong>

          <strong v-else> {{ field.key }}: </strong>

          <span
            v-if="['hidden', 'text', 'datetime'].includes(field.type)"
            class="float-right"
          >
            {{ formValues[field.key] }}
          </span>

          <b-img
            v-else-if="field.type == 'file'"
            right
            :src="formValues[field.key]"
          ></b-img>

          <span
            v-else-if="field.type == 'ckeditor'"
            v-html="formValues[field.key]"
            class="float-right"
          ></span>

          <ul v-else-if="field.type == 'contactoptions'" class="float-right">
            <li
              v-for="(contactOption, index) in formValues[field.key]"
              :key="index"
            >
              {{ contactOption }}
            </li>
          </ul>

          <ul v-else-if="field.type == 'options'" class="float-right">
            <li v-for="(option, index) in formValues[field.key]" :key="index">
              <b-img v-if="option.icon" :src="option.icon"></b-img>
              <span v-if="option.option">{{ option.option }}</span>
            </li>
          </ul>
        </b-list-group-item>
      </b-list-group>
      <b-button
        @click="cancelVote"
        v-if="status == 'started'"
        class="mb-2"
        variant="danger"
        >Tühista hääletamine</b-button
      >
      <b-button
        :to="{ name: 'VotingResults', params: { id: id } }"
        class="mb-2"
        variant="info"
        >Vaata tulemusi</b-button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { Settings } from "luxon";
import LivePreview from "./livePreview";

Settings.defaultLocale = "et";

export default {
  name: "QuestionEdit",
  props: {
    id: {
      default: null
    }
  },
  components: {
    LivePreview,
    ckeditor: CKEditor.component,
    datetime: Datetime
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "link",
          "bulletedList",
          "numberedList",
          "blockQuote",
          "undo",
          "redo"
        ]
      },
      tmpSponsorLogo: null,
      tmpOptionsIcon: [],
      formValues: {
        id: null,
        question: null,
        sponsor_logo: null,
        brand_color: null,
        campaign_rules: null,
        required_contact_fields: [],
        optional_contact_fields: [],
        raffle_name: null,
        raffle_description: null,
        publish_time: null,
        end_time: null,
        options: []
      },
      formFields: {
        question: [
          {
            key: "id",
            type: "hidden"
          },
          {
            key: "question",
            type: "text",
            label: "Küsimus",
            required: true,
            invalidFeedback: ""
          },
          {
            key: "sponsor_logo",
            type: "file",
            label: "Sponsori logo",
            description:
              "Logo peab olema .svg formaadis vector logo läbipaistval taustal",
            invalidFeedback: ""
          },
          {
            key: "brand_color",
            type: "color",
            label: "Kampaania kuva toon",
            description:
              "6 kohaline HEX värvikood ilma #'ta, see väärtus muudab tele kuvas kasutatavaid toone",
            invalidFeedback: ""
          },
          {
            key: "campaign_rules",
            type: "ckeditor",
            label: "Hääletamise reeglid",
            required: true,
            invalidFeedback: ""
          },
          {
            key: "required_contact_fields",
            type: "contactoptions",
            label: "Kohustuslikud kontakti väljad",
            description:
              "Need väljad saavad hääletamisel kõik kohustuslikud olema",
            invalidFeedback: ""
          },
          {
            key: "optional_contact_fields",
            type: "contactoptions",
            label: "Valikulised kontakti väljad",
            description:
              "Kui valitud 1, siis on see vabatahtlik väli, kui rohkem, siis peab hääletamisel kasutaja täitma nendest vähemalt ühe",
            invalidFeedback: ""
          },
          {
            key: "raffle_name",
            type: "text",
            label: "Loosimise üleskutse",
            description:
              'Üleskutse, mis saab olema kuvatud linnukesega valitavana hääletamise vormil. Selle täitmisel on vajalik ka "Loosimise reeglite" täitmine',
            invalidFeedback: ""
          },
          {
            key: "raffle_description",
            type: "ckeditor",
            label: "Loosimise reeglid",
            invalidFeedback: ""
          },
          {
            key: "publish_time",
            type: "datetime",
            label: "Hääletamise algusaeg",
            invalidFeedback: ""
          },
          {
            key: "end_time",
            type: "datetime",
            label: "Hääletamise lõpu aeg",
            invalidFeedback: ""
          },
          {
            key: "options",
            type: "options",
            label: "Vastusevariandid",
            invalidFeedback: ""
          }
        ],
        options: [
          {
            key: "id",
            type: "hidden"
          },
          {
            key: "option",
            type: "text",
            label: "Vastusevariant",
            required: true
          },
          {
            key: "has_free_text",
            type: "boolean",
            label: "Vabatekstiga vastus"
          },
          {
            key: "icon",
            type: "file",
            label: "Ikoon"
          }
        ]
      },
      contactOptions: [
        {
          text: "Nimi",
          value: "name"
        },
        {
          text: "Telefon",
          value: "phone"
        },
        {
          text: "E-mail",
          value: "email"
        }
      ],
      error: "",
      validationError: "",
      isBusy: false,
      status: null
    };
  },
  methods: {
    validateFields() {
      this.validationError = "";

      let errors = [];

      let publishDate = new Date(this.formValues.publish_time);
      let endTime = new Date(this.formValues.end_time);
      let timeNow = new Date();

      // Validate main form fields
      for (let field in Object.keys(this.formFields.question)) {
        this.formFields.question[field].invalidFeedback = "";

        if (
          this.formFields.question[field].required &&
          !this.formValues[this.formFields.question[field].key]
        ) {
          this.formFields.question[field].invalidFeedback =
            "Väli on kohustuslik!";
          errors.push(this.formFields.question[field].key);
        }

        if (
          this.formFields.question[field].key == "publish_time" &&
          this.formValues.publish_time &&
          publishDate.getTime() <= timeNow.getTime()
        ) {
          this.formFields.question[field].invalidFeedback =
            "Algusaeg peab olema tulevikus!";
          errors.push(this.formFields.question[field].key);
        } else if (
          this.formFields.question[field].key == "end_time" &&
          this.formValues.publish_time &&
          this.formValues.end_time &&
          publishDate.getTime() >= endTime.getTime()
        ) {
          this.formFields.question[field].invalidFeedback =
            "Lõpu aeg peab olema hiljem, kui alguse aeg!";
          errors.push(this.formFields.question[field].key);
        } else if (
          this.formFields.question[field].key == "raffle_description" &&
          this.formValues.raffle_name &&
          !this.formValues.raffle_description
        ) {
          this.formFields.question[field].invalidFeedback =
            "Kui on määratud loosimise üleskutse, on ka loosimise reeglid kohustuslikud!";
          errors.push(this.formFields.question[field].key);
        } else if (
          this.formFields.question[field].type == "color" &&
          this.formValues[this.formFields.question[field].key] &&
          !/^[\da-fA-F]{6}$/.test(
            this.formValues[this.formFields.question[field].key]
          )
        ) {
          this.formFields.question[field].invalidFeedback =
            "Väärtus peab olema valiidne 6 kohaline HEX värvi kood";
          errors.push(this.formFields.question[field].key);
        }
      }

      if (errors.length) {
        this.validationError = "Viga sisestatud andmetes";
        window.scrollTo(0, 0);
        return false;
      }

      return true;
    },
    prepareData() {
      let optionsToBeRemoved = [];

      for (let i in this.formValues.options) {
        if (
          !this.formValues.options[i].icon &&
          !this.formValues.options[i].option
        ) {
          optionsToBeRemoved.push(i);
        }
      }
      for (let i = optionsToBeRemoved.length - 1; i >= 0; i--) {
        this.removeOption(optionsToBeRemoved[i]);
      }

      let requestData = Object.assign({}, this.formValues);
      if (
        requestData.sponsor_logo &&
        requestData.sponsor_logo.indexOf("data:image") != 0
      ) {
        delete requestData.sponsor_logo;
      }
      if (!requestData.id) {
        delete requestData.id;
      }
      requestData.options.map((option, index) => {
        if (option.icon && option.icon.indexOf("data:image") != 0) {
          delete requestData.options[index].icon;
        }
        if (!option.id) {
          delete requestData.options[index].id;
        }
      });
      if (requestData.publish_time && requestData.end_time) {
        requestData.publish_time = requestData.publish_time
          .replace("T", " ")
          .slice(0, 19);
        requestData.end_time = requestData.end_time
          .replace("T", " ")
          .slice(0, 19);
      }

      console.log(requestData, "requestData");
      console.log(this.formValues, "formValues");

      return requestData;
    },
    onSubmit(evt, noRedirect = null) {
      evt.preventDefault();

      if (this.validateFields()) {
        let requestData = this.prepareData();

        if (this.id) {
          // PUT update
          this.putData(requestData, noRedirect);
        } else {
          // POST new
          this.postData(requestData, noRedirect);
        }
      }
    },
    startVoting() {
      if (
        confirm(
          "Küsimust ei ole enam peale alustamist võimalik muuta. Kas oled kindel ,et soovid hääletamist alustada?"
        )
      ) {
        if (this.formValues.options.length) {
          this.onSubmit(new CustomEvent("startVoting"), true);
          axios
            .put(
              process.env.VUE_APP_BACKEND_HOST +
                "/api/v1/questions/" +
                this.id +
                "/start",
              {},
              {
                timeout: 5000
              }
            )
            .then(() => {
              this.$router.push({
                name: "admin",
                params: {
                  callbackMessage: {
                    message:
                      'Hääletamine küsimusele "' +
                      this.formValues.question +
                      '" alustatud',
                    variant: "success"
                  }
                }
              });
            })
            .catch(err => {
              console.log(err);
              this.validationError =
                "Hääletamist saab avada vaid küsimustele, millel on algus ja lõpu ajad seatud.\nFunktsioon on mõeldud hääletamise ennetähtaegseks avamiseks.";
              window.scrollTo(0, 0);
            });
        } else {
          this.validationError =
            "Hääletamise alustamiseks, peab küsimusel olema vastusevariante";
          window.scrollTo(0, 0);
        }
      }
    },
    deleteQuestion() {
      if (confirm("Kas soovid kindlasti küsimust kustutada?")) {
        axios
          .delete(
            process.env.VUE_APP_BACKEND_HOST + "/api/v1/questions/" + this.id,
            {
              timeout: 5000
            }
          )
          .then(() => {
            this.$router.push({
              name: "admin",
              params: {
                callbackMessage: {
                  message: "Küsimus kustutatud",
                  variant: "success"
                }
              }
            });
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    cancelVote() {
      if (confirm("Soovid kindlasti hääletamist tühistada?")) {
        axios
          .put(
            process.env.VUE_APP_BACKEND_HOST +
              "/api/v1/questions/" +
              this.id +
              "/cancel",
            {},
            {
              timeout: 5000
            }
          )
          .then(() => {
            this.$router.push({
              name: "admin",
              params: {
                callbackMessage: {
                  message:
                    'Hääletamine küsimusele "' +
                    this.formValues.question +
                    '" tühistatud',
                  variant: "success"
                }
              }
            });
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    addOption(option = null) {
      // Passed parameter is not an option but an event
      if (option.target) {
        this.formValues.options.push({
          id: null,
          option: null,
          has_free_text: 0,
          icon: null
        });
      } else {
        this.formValues.options.push({
          id: option.id,
          option: option.option,
          has_free_text: option.has_free_text,
          icon: option.icon
        });
      }
      this.tmpOptionsIcon.push(null);
    },
    removeOption(index) {
      this.formValues.options.splice(index, 1);
      this.tmpOptionsIcon.splice(index, 1);
    },
    setNull(...indexes) {
      let nullableElement = this.formValues;
      for (let i = indexes.length - 1; i > 0; i--) {
        nullableElement = nullableElement[indexes[i]];
      }
      nullableElement[indexes[0]] = null;
    },
    fetchQuestion(id) {
      this.isBusy = true;
      axios
        .get(process.env.VUE_APP_BACKEND_HOST + "/api/v1/questions/" + id, {
          timeout: 5000
        })
        .then(response => {
          this.error = "";
          console.log(response.data);
          for (let field in response.data) {
            if (
              field != "options" &&
              this.formValues[field] !== undefined &&
              response.data[field]
            ) {
              this.formValues[field] = response.data[field];
              if (field == "publish_time" || field == "end_time") {
                this.formValues[field] = response.data[field].replace(" ", "T");
              }
            } else if (field == "options" && response.data[field].length) {
              for (let option in response.data[field]) {
                this.addOption(response.data[field][option]);
              }
            } else if (field == "status") {
              this.status = response.data[field];
            }
          }
        })
        .catch(() => {
          this.error = "Viga serveriga";
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
    postData(data, noRedirect = null) {
      console.log(data, noRedirect);
      axios
        .post(process.env.VUE_APP_BACKEND_HOST + "/api/v1/questions", data, {
          timeout: 5000
        })
        .then(() => {
          if (!noRedirect) {
            this.$router.push({
              name: "admin",
              params: {
                callbackMessage: {
                  message: "Küsimus edukalt salvestatud",
                  variant: "success"
                }
              }
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    putData(data, noRedirect = null) {
      console.log(data);
      axios
        .put(
          process.env.VUE_APP_BACKEND_HOST + "/api/v1/questions/" + this.id,
          data,
          {
            timeout: 5000
          }
        )
        .then(() => {
          if (!noRedirect) {
            this.$router.push({
              name: "admin",
              params: {
                callbackMessage: {
                  message: "Küsimus edukalt muudetud",
                  variant: "success"
                }
              }
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted: function() {
    if (this.id) {
      this.fetchQuestion(this.id);
    }
  },
  computed: {
    optionIconWatcherHelper() {
      return Object.assign({}, this.tmpOptionsIcon);
    }
  },
  watch: {
    tmpSponsorLogo(newFile) {
      if (newFile) {
        const reader = new FileReader();
        reader.onload = e => {
          this.formValues.sponsor_logo = e.target.result;
        };
        reader.readAsDataURL(newFile);
      }
    },
    optionIconWatcherHelper: {
      handler(newValue, oldValue) {
        // Unnecessary to process if item removed, everything will be in place
        if (Object.keys(newValue).length >= Object.keys(oldValue).length) {
          for (let icon in newValue) {
            if (
              newValue[icon] &&
              (!oldValue[icon] || oldValue[icon] !== newValue[icon])
            ) {
              const reader = new FileReader();
              reader.onload = e => {
                this.formValues.options[icon].icon = e.target.result;
              };
              reader.readAsDataURL(newValue[icon]);
            }
          }
        }
      },
      deep: true
    },
    "formValues.required_contact_fields": {
      handler(newValue) {
        // No point in processing if the other field doesn't have values
        if (this.formValues.optional_contact_fields) {
          for (let i in newValue) {
            let tmpIndex = this.formValues.optional_contact_fields.indexOf(
              newValue[i]
            );
            if (tmpIndex > -1) {
              this.formValues.optional_contact_fields.splice(tmpIndex, 1);
            }
          }
        }
      }
    },
    "formValues.optional_contact_fields": {
      handler(newValue) {
        if (this.formValues.required_contact_fields) {
          // No point in processing if the other field doesn't have values
          if (this.formValues.required_contact_fields) {
            for (let i in newValue) {
              let tmpIndex = this.formValues.required_contact_fields.indexOf(
                newValue[i]
              );
              if (tmpIndex > -1) {
                this.formValues.required_contact_fields.splice(tmpIndex, 1);
              }
            }
          }
        }
      }
    }
  }
};
</script>
